module.exports = {
  Webpage: {
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    PluginName: "Web Incrustada",
    radius: "Radio",
    source: "Origen",
    URL: "URL",
    URL_copypaste: "Copia y pega una URL",
    fixedPosition: "Quitar Scroll",
  },
};
